import { useEffect, useRef, useState } from 'react'
import { ErrorState } from '../state'
import { noteFundMenu } from '../fundScope'
import SearchResults from './SearchResults'
import './navigation.css'
export default function ContextFindDialog({
  onClose,
  error,
}: {
  onClose: () => void
  error?: unknown
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const input = useRef<HTMLInputElement>(null)
  const [query, setQuery] = useState('')
  useEffect(() => {
    const previous = document.activeElement
    const element = dialog.current
    element?.showModal()
    input.current?.focus()
    noteFundMenu(1)
    return () => {
      noteFundMenu(-1)
      element?.close()
      if (previous instanceof HTMLElement && previous.isConnected) previous.focus()
    }
  }, [])
  return (
    <dialog
      ref={dialog}
      className="find-dialog"
      aria-labelledby="context-find-title"
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <header>
        <h2 id="context-find-title">Find</h2>
        <button onClick={onClose}>Close ×</button>
      </header>
      <p>Clients, funds and issuers</p>
      <input
        ref={input}
        aria-label="Find by name"
        placeholder="Type a name…"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      <div className="find-results">
        {error ? (
          <ErrorState what="name search" error={error} />
        ) : (
          <SearchResults query={query} onChoose={onClose} />
        )}
        {!query.trim() ? <p>Enter a client, fund or issuer name.</p> : null}
      </div>
    </dialog>
  )
}
